import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Image from '../../assets/BannerCelfocus.jpg';
import { ReactComponent as VersionsIcon } from '../../assets/versions.svg';
import { Link } from 'react-router-dom';
import { ReleaseTable } from '../../components/ReleaseTable';

const useStyles = makeStyles({
    grid: {
        fontFamily: 'SourceSansPro-Regular',
        height: 370,
        backgroundImage: `url(${Image})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover"
    },
    tableContainer: {
        marginBottom: 40
    },
    releasesHeader: {
        textAlign: 'center',
        color: 'white'
    },
    containerBlock: {
        paddingTop: 105
    },
    h2: {
        fontFamily: 'Gotham-Book',
        fontSize: 32,
        letterSpacing: -1,
        color: 'white',
        padding: '0px 20px 10px 20px',
        textAlign: 'center'
    },
    link: {
        fontFamily: 'SourceSansPro-Regular',
        color: '#1f96a2',
        cursor: 'pointer'
    },
    collapsedRow: {
        cursor: 'pointer'
    }
});

export const ReleasePage = ({ title, jsonUrl, mainReleaseType, subReleaseType }) => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);

    useEffect(() => {
        fetch(jsonUrl)
            .then((res) => res.json())
            .then(
                (data) => {
                    const releases = data.releases;
                    const mainReleases = releases.filter(r => mainReleaseType.includes(r.supportType));
                    const subReleases = releases.filter(r => r.supportType === subReleaseType);

                    const grouped = mainReleases.map(main => {
                        const mainVersionPrefix = main.internalVersion.substring(0, main.internalVersion.lastIndexOf('.'));
                        const childReleases = subReleases.filter(sub => sub.internalVersion.startsWith(mainVersionPrefix + '.') && sub.internalVersion !== main.internalVersion);

                        childReleases.sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate));

                        return { ...main, subReleases: childReleases };
                    });

                    const activeReleases = grouped.filter(r => r.state.includes('Active'));
                    setExpandedRows(activeReleases.map(r => r.version));
                    setData(grouped);
                },
                (error) => {
                    console.log(error);
                }
            );
    }, [jsonUrl, mainReleaseType, subReleaseType]);

    const handleRowClick = (version) => {
        const currentIndex = expandedRows.indexOf(version);
        const newExpandedRows = [...expandedRows];

        if (currentIndex === -1) {
            newExpandedRows.push(version);
        } else {
            newExpandedRows.splice(currentIndex, 1);
        }

        setExpandedRows(newExpandedRows);
    };

    const isExpanded = (version) => expandedRows.indexOf(version) !== -1;

    return (
        <div className={classes.grid}>
            <div className="returnToHome">
                <Link to={"/"} variant="outlined" size="large" className={classes.backButton}>&lt; Return to Homepage</Link>
            </div>
            <div className={`container ${classes.containerBlock}`}>
                <div className={classes.releasesHeader}>
                    <VersionsIcon style={{ height: '56', width: '56', fill: 'white' }} title="" />
                    <h2 className={classes.h2}>{title}</h2>
                </div>
                <ReleaseTable
                    data={data}
                    expandedRows={expandedRows}
                    handleRowClick={handleRowClick}
                    isExpanded={isExpanded}
                />
            </div>
        </div>
    )
}
